module.exports = __webpack_public_path__ + "img/img3-3.07b0b9af.png";